import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=6dbf213e&scoped=true"
import script from "./BookDetail.vue?vue&type=script&lang=js"
export * from "./BookDetail.vue?vue&type=script&lang=js"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=6dbf213e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf213e",
  null
  
)

export default component.exports